/** @format */
import Sidebar from "./Sidebar";
import Header from "./Header";
import { Outlet } from "react-router-dom";
import React, { createContext, useState, useContext } from "react";

const ExtractContext = createContext();

export const useExtract = () => useContext(ExtractContext);

const Main = () => {
  const [isExtract, setIsExtract] = useState(false);

  return (
    <ExtractContext.Provider value={{ isExtract, setIsExtract }}>
      <div className={`wrapper ${isExtract ? 'disabled-screen' : ''}`}>
        <Sidebar context={{ isExtract, setIsExtract }} />
        <div id="content" className="contentOutlet">
          <Header
          //  socket={socket}
            context={{ isExtract, setIsExtract }} />
          <Outlet context={{ isExtract, setIsExtract }} />
        </div>
      </div>
    </ExtractContext.Provider>
  );
};
export default Main;